import React, { useEffect, useState } from "react";
import vector1 from "../assets/Vector 217.png";
import vector2 from "../assets/Vector 218.png";
import "./currencyRate.css";

const mockData = [
    {
        id: 1,
        name: 'Hong Kong Dollar',
        buy: '234.12',
        sell: '667'
    },
    {
        id: 2,
        name: 'US Dollar',
        buy: '234.12',
        sell: '667'
    },
    {
        id: 3,
        name: 'Russian Dollar',
        buy: '234.12',
        sell: '667'
    },
    {
        id: 4,
        name: 'Won',
        buy: '234.12',
        sell: '667'
    },
    {
        id: 6,
        name: 'Yuan',
        buy: '24.12',
        sell: '667'
    },
    {
        id: 7,
        name: 'Hong Kong Dollar',
        buy: '234.12',
        sell: '667'
    },
    {
        id: 8,
        name: 'US Dollar',
        buy: '234.12',
        sell: '667'
    },
    {
        id: 9,
        name: 'Russian Dollar',
        buy: '234.12',
        sell: '667'
    },
];

function CurrencyRate() {
    const [data, setData] = useState([]);
    const [point, setPoint] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        fetch('https://api.example.com/currency-rates')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => setData(data))
            .catch(() => setData(mockData));
    }, []);

    const handleNext = () => {
        if (point < data.length - 3) {
            setPoint(point + 1);
        }
    };

    const handlePrev = () => {
        if (point > 0) {
            setPoint(point - 1);
        }
    };

    const handleViewAll = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="currencyrate">
            <div style={{marginRight:'15px'}}>
                <div style={{display:'flex',justifyContent:'center',alignItems:'center',padding:'15px',fontSize:'30px'}}>
                    Currency Rate Cards
                </div>
            </div>
                <div style={{display:'flex',flexDirection:'row',width:'80%'}}>
                    <div className="currencycard">
                        <div className="buttonArrow">
                            <button onClick={handlePrev} disabled={point === 0}><img src={vector1} alt="Previous" /></button>
                        </div>
                        <div>
                            <div>{data[point]?.name}</div>
                            <div>Buy: {data[point]?.buy}</div>
                            <div>Sell: {data[point]?.sell}</div>
                        </div>
                        <div>
                            <div>{data[point + 1]?.name}</div>
                            <div>Buy: {data[point + 1]?.buy}</div>
                            <div>Sell: {data[point + 1]?.sell}</div>
                        </div>
                        <div>
                            <div>{data[point + 2]?.name}</div>
                            <div>Buy: {data[point + 2]?.buy}</div>
                            <div>Sell: {data[point + 2]?.sell}</div>
                        </div>
                        <div className="buttonArrow">
                            <button onClick={handleNext} disabled={point >= data.length - 3}><img src={vector2} alt="Next" /></button>
                        </div>
                    </div>

                    <div className="viewall" onClick={handleViewAll}>
                        View All
                    </div>
                </div>

            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={handleCloseModal}>&times;</span>
                        <div style={{display:'flex',flexDirection:'row'}}>
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <label>Search</label>
                                <input type="text" placeholder="Search currency..." />
                            </div>
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <label>Select City</label>
                                <select type="select">
                                    <option value="usd">Bokaro</option>
                                    <option value="eur">Bangalore</option>
                                    <option value="gbp">Manipal</option>
                                    <option value="jpy">Ranchi</option>
                                </select>
                            </div>
                        </div>
                        <table className="currency-table" id="currency-table">
                                <tr>
                                    <th>Currency</th>
                                    <th style={{width:'90%'}}>Rates</th>
                                </tr>
                                {data.map((currency) => (
                                    <tr key={currency.id}>
                                        <td>{currency.name}</td>
                                        <td colSpan={2}>{currency.sell}</td>
                                    </tr>
                                ))}
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CurrencyRate;